export const DETECTED_REGION_ID_COOKIE_KEY = 'detectedRegionId';
